import React, { FC } from 'react';

import { MetaMode } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Meta/Meta.types';
import { isFilmPlayerMeta, presentTitle } from '@/shared/lib/movie';
import { usePlayerData } from '@/scenarios/player/hooks/usePlayerData';

import { PlayerHead } from '../../feature-player/ui/player-head/component';
import { MoviePlayerMeta } from '../../movie-player/ui/MoviePlayerMeta';
import { getMovieMetaLogo } from '../../movie-player/utils/get-movie-meta-logo';
import { useEditorAnnotationVisible } from '../hooks/useEditorAnnotationVisible';

interface Props {
    movieId: string;
    className?: string;
    isControlsVisible: boolean;
    mode?: MetaMode;
}

export const FilmPlayerMetaContainer: FC<Props> = ({
    movieId,
    className,
    isControlsVisible,
    mode = MetaMode.DEFAULT,
}) => {
    const { playerMeta } = usePlayerData(movieId);
    const isEditorAnnotationVisible = useEditorAnnotationVisible(isControlsVisible);

    if (!isFilmPlayerMeta(playerMeta)) {
        return null;
    }

    const { title, editorAnnotation, horizontalLogo } = playerMeta.movieMeta;
    const logo = getMovieMetaLogo(horizontalLogo);
    const metaTitle = presentTitle(title);

    return (
        <>
            <PlayerHead playerMeta={playerMeta} />
            {isControlsVisible && (
                <MoviePlayerMeta
                    title={metaTitle || ''}
                    logoUrl={logo?.logoUrl}
                    logoWidth={logo?.width}
                    logoHeight={logo?.height}
                    className={className}
                    editorAnnotation={
                        isEditorAnnotationVisible && editorAnnotation ? editorAnnotation : undefined
                    }
                    mode={mode}
                />
            )}
        </>
    );
};
